export default function AdyenWidgetLoadingSkeleton() {
  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex w-full animate-pulse flex-col gap-2 bg-gray-100 p-4">
        <div className="flex gap-2">
          <div className="bg-gray-150 h-6 w-10 animate-pulse" />
          <div className="bg-gray-150 h-6 w-40 animate-pulse" />
        </div>
        <div className="bg-gray-150 col-span-full h-12 w-full animate-pulse" />
      </div>
      <div className="h-16 w-full animate-pulse bg-gray-100" />
      <div className="h-16 w-full animate-pulse bg-gray-100" />
      <div className="h-16 w-full animate-pulse bg-gray-100" />
      <div className="h-16 w-full animate-pulse bg-gray-100" />
    </div>
  );
}
